import sample_thumbnail_01 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_01.png";
import sample_thumbnail_02 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_02.png";
import sample_thumbnail_03 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_03.png";
import sample_thumbnail_04 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_04.png";
import sample_thumbnail_05 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_05.png";
import sample_thumbnail_06 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_06.png";
import sample_thumbnail_07 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_07.png";
import sample_thumbnail_08 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_08.png";
import sample_thumbnail_09 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_09.png";
import sample_thumbnail_10 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_10.png";
import sample_thumbnail_11 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_11.png";
import sample_thumbnail_12 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_12.png";
import sample_thumbnail_13 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_13.png";
import sample_thumbnail_14 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_14.png";
import sample_thumbnail_15 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_15.png";
import sample_thumbnail_16 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_16.png";
import sample_thumbnail_17 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_17.png";
import sample_thumbnail_18 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_18.png";
import sample_thumbnail_19 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_19.png";
import sample_thumbnail_20 from "../assets/sampleSkillpathThumbnails/sample_thumbnail_20.png";

const thumbnails = [
  sample_thumbnail_01,
  sample_thumbnail_02,
  sample_thumbnail_03,
  sample_thumbnail_04,
  sample_thumbnail_05,
  sample_thumbnail_06,
  sample_thumbnail_07,
  sample_thumbnail_08,
  sample_thumbnail_09,
  sample_thumbnail_10,
  sample_thumbnail_11,
  sample_thumbnail_12,
  sample_thumbnail_13,
  sample_thumbnail_14,
  sample_thumbnail_15,
  sample_thumbnail_16,
  sample_thumbnail_17,
  sample_thumbnail_18,
  sample_thumbnail_19,
  sample_thumbnail_20,
];

const hashStringToNumber = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i); // Convert to 16bit integer
    hash = (hash << 5) - hash + char; // Bitwise shift and subtraction
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

// Helper function to assign the same random thumbnail to a skillpath skill or goal based on the item id
export const getThumbnailForSkillpath = (id) => {
  const hash = hashStringToNumber(id);
  const index = hash % thumbnails.length; 
  return thumbnails[index];
};
